import loadable from '@loadable/component';

export const AsyncRecentTravelerActivity = loadable(() =>
    import(
        /* webpackChunkName: "recent-traveler-activity" */
        './'
    )
);

AsyncRecentTravelerActivity.displayName = 'AsyncRecentTravelerActivity';
